import React from 'react';
import PropTypes from 'prop-types';
import httpClient from 'axios';
import { WestpacPayment } from '@PetSureAustralia/petsure-react-payment-components';
import { PreloadWrapper } from '../../../preloadWrapper/preloadWrapper';
import { useLegacyUpdatePremiumPayment } from './useLegacyUpdatePremiumPayment';
import { FullPetDetailsPropTypes } from '../../../../propTypes/petDetails';

export const LegacyUpdatePremiumPayment = ({
  activePet,
  petDetails,
  onCancel,
  setShowSuccessMessage,
  isPartnerUsingLegacyPayment
}) => {
  const {
    updateIsLoading,
    westPacPaymentConfig,
    handleBackToSummary,
    handleBeforeSubmit,
    handleSubmitFail,
    handleSubmitSuccess,
    policyDetails,
    showFailedUpdateError
  } = useLegacyUpdatePremiumPayment(
    activePet,
    petDetails,
    onCancel,
    setShowSuccessMessage,
    isPartnerUsingLegacyPayment
  );

  return (
    <div className="petSureForm verticalStacked premiumPaymentPopup">
      <PreloadWrapper
        isLoading={updateIsLoading}
        customCssClass="custom-preload-wrapper"
      >
        <WestpacPayment
          config={westPacPaymentConfig}
          httpClient={httpClient}
          onBackToSummary={handleBackToSummary}
          onBeforeSubmit={handleBeforeSubmit}
          onSubmitFail={handleSubmitFail}
          onSubmitSuccess={handleSubmitSuccess}
          policy={policyDetails}
        />
        {showFailedUpdateError && (
          <div className="error-message-container">
            <span className="error-message">
              Sorry, we couldn&apos;t update your details at this time. Please try again in a few minutes or
              <a
                href="/contact-us"
                rel="noreferrer"
              >
                &nbsp;contact us&nbsp;
              </a>
              for assistance.
            </span>
          </div>
        )}
      </PreloadWrapper>
    </div>
  );
};

LegacyUpdatePremiumPayment.propTypes = {
  activePet: FullPetDetailsPropTypes,
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  onCancel: PropTypes.func,
  setShowSuccessMessage: PropTypes.func,
  isPartnerUsingLegacyPayment: PropTypes.bool
};
